/*globals cpac, $j */

if (typeof cpac !== 'undefined') {
  cpac.HotKeys = {
    _courtIconsOn: false,
    
    initCourtIcons: function() {
        if (this._courtIconsOn) {
            return false;
        }
        $j("body").keypress(function(ev) {cpac.HotKeys.viewCourtIcons(ev)});
        this._courtIconsOn = true;
    },	
    viewCourtIcons: function(ev) {
        var sElement = typeof(ev.srcElement) == 'undefined' ? ev.target : ev.srcElement;
        var keyCode = ev.which ? ev.which : ev.keyCode;
        var notInput = sElement && (sElement.tagName != 'INPUT' || sElement.type != 'text') && sElement.tagName != 'TEXTAREA';
        if (notInput) {
            if (keyCode == 73 || keyCode == 105) {
                $j('.hidden-icon').toggle();
            }
        }
    }
  }
}